import {makeStyles} from "@material-ui/core";

export default function UsuariosListaCss() {
    return makeStyles(theme => ({
        root: {
            margin: 0
        },
        externalDiv: {
            width: '100%'
        }
    }));
}